import { render, staticRenderFns } from "./UserPass.vue?vue&type=template&id=40fc9821&scoped=true"
import script from "./UserPass.vue?vue&type=script&lang=js"
export * from "./UserPass.vue?vue&type=script&lang=js"
import style0 from "./UserPass.vue?vue&type=style&index=0&id=40fc9821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc9821",
  null
  
)

export default component.exports